<template>
    <div class="agency-client-landing-page">
        <div class="row">
            <div :class="(user.user_type=='agency_admin' || user.user_type =='admin')? 'col-md-6 col-lg-3 col-12':'col-md-6 col-lg-4 col-12'">
                <div class="card d-flex flex-row">
                    <div class="flex-shrink-1 insights-dashboard-group-icon mt-2 me-2 p-3 circle-icon-green">
                        <img class="icon mb-2" src="/img/icons/avid-icons/dollar-square.svg" alt="">
                    </div>
                    <div class="flex-fill p-1" >
                        <p class="mb-2">Total Revenue</p>

                        <div class="align-items-center d-flex">
                            <h3 class="mb-0">
                                {{ currency_with_zero(clients_summary.revenue_current_period) }}
                            </h3>
                            <span class="badge ms-2" :class="{ 'bg-green bg-icon-increase':( clients_summary.revenue_percentage_change > 0), 'bg-red bg-icon-decrease': (clients_summary.revenue_percentage_change < 0)}">
                                {{ percentage_na(clients_summary.revenue_percentage_change) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="(user.user_type=='agency_admin' || user.user_type =='admin')? 'col-md-6 col-lg-3 col-12':'col-md-6 col-lg-4 col-12'">
                <div class="card d-flex flex-row">
                    <div class="flex-shrink-1 insights-dashboard-group-icon mt-2 me-2 p-3 circle-icon-yellow">
                        <img class="icon mb-2" src="/img/icons/avid-icons/gift.svg" alt="">
                    </div>
                    <div class="flex-fill p-1" >
                        <p class="mb-2">Total Gifts</p>

                        <div class="align-items-center d-flex">
                            <h3 class="mb-0">
                                {{ number_with_zero(clients_summary.gifts_current_period) }}
                            </h3>
                            <span class="badge ms-2" :class="{ 'bg-green bg-icon-increase':( clients_summary.gifts_percentage_change > 0), 'bg-red bg-icon-decrease': (clients_summary.gifts_percentage_change < 0)}">
                                {{ percentage_na(clients_summary.gifts_percentage_change) }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div :class="(user.user_type=='agency_admin' || user.user_type =='admin')? 'col-md-6 col-lg-3 col-12':'col-md-6 col-lg-4 col-12'">
                <div class="card d-flex flex-row">
                    <div class="flex-shrink-1 insights-dashboard-group-icon mt-2 me-2 p-3 circle-icon-blue">
                        <img class="icon mb-2" src="/img/icons/avid-icons/people.svg" alt="">
                    </div>
                    <div class="flex-fill p-1" >
                        <p class="mb-2">Total Donors</p>

                        <div class="align-items-center d-flex">
                            <h3 class="mb-0">
                                {{ number_with_zero(clients_summary.donors_current_period) }}
                            </h3>
                            <span class="badge ms-2" :class="{ 'bg-green bg-icon-increase':( clients_summary.donors_percentage_change > 0), 'bg-red bg-icon-decrease': (clients_summary.donors_percentage_change < 0)}">
                                {{ percentage_na(clients_summary.donors_percentage_change) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="user.user_type=='agency_admin' || user.user_type =='admin'" class="col-md-6 col-lg-3 col-12">
                <a :href="addClientUrl()" class="btn btn-primary mb-2 ms-2 float-end">
                    <span>
                        <i class="fas fa-fw fa-plus"></i>
                        Add Client
                    </span>
                </a>

                <a href="/admin/agency/profile" class="btn btn-white mb-2 float-end">
                    <span>
                        <img class="icon" src="/img/icons/avid-icons/settings.svg" alt="">
                        Agency Settings
                    </span>
                </a>
            </div>
        </div>

        <div class="card my-3 table-card">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <h3 class="mt-2">Clients ({{ filtered_clients.length }})</h3>
                    </div>

                    <div class="col-lg-6 d-none d-lg-block">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input type="text" placeholder="Search by Client Name..." aria-label="Search by Client Name..." v-model="search_key" @input="handleFilterSelection()" autocomplete="one-time-code" class="search-box form-control me-1 py-2">
                                <i class="fa fa-search search-placeholder-icon" v-if="search_key === ''"></i>
                            </div>
                            <button class="btn btn-secondary me-1 py-0 dropdown-toggle dropdown-toggle-no-btn" data-bs-toggle="dropdown"  data-bs-auto-close="outside" aria-expanded="false">
                                <img class="icon" src="/img/icons/avid-icons/filter-funnel-01.svg" alt="">Filters ({{ filters.agency_user && filters.agency_user.value == -1 ? '1':'2' }})
                            </button>
                            <div class="dropdown-menu dropdown-menu-primary p-3">
                                <p>Time Period Selected for Recent Results:</p>
                                <select class="form-select" v-model="filters.time_period" @change="saveTimePeriod()" aria-label="Time Period">
                                    <option value="current_month">Current Month</option>
                                    <option value="last_month">Last Month</option>
                                    <option value="fytd">Fiscal Year to Date</option>
                                </select>

                                <hr>

                                <p>Limit Clients by User:</p>
                                <v-select :options="filtered_agency_users" v-model="filters.agency_user"
                                    :searchable="true" class="searchable-select"
                                    :selectable="(option) => option.text != ''"
                                    label="text" @search="fetchClientOptions"
                                    @update:modelValue="handleFilterSelection()"
                                    :filterable="false"
                                    >
                                    <template #selected-option="{ text, category }">
                                    {{(category != null&& category != ''&& text!=null && text!="") ? category + ": " : ""}}{{text}}
                                    </template>

                                    <template #open-indicator="{ attributes }">
                                    <span v-bind="attributes" style="width: 12px; line-height: 8px;"><svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#343a40' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg></span>
                                    </template>

                                    <template #option="{ text, category }">
                                    <div v-if="text == ''" :data-category="category" class="category-header"
                                        @click="expandCategory(category, null)"
                                        data-isexpanded="false">
                                        {{ category }} <i class="fas fa-caret-right"></i>
                                    </div>
                                    <div v-else class="suboption" :data-subcategory="category"
                                        :class="category==null || category==''? 'show' : ''">
                                        {{ text }}
                                    </div>
                                    </template>
                                    <template #no-options="{ search, searching, loading }">
                                        <div class="suboption show">
                                            <em>No results found</em>
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0 agency-client-table">
                        <thead>
                            <tr class="table-header-row">
                                <th @click="sortByKey('name')" class="table-column-1 d-table-cell">
                                    <div class="d-flex flex-row">
                                        Name
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'name' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'name' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click="sortByKey('plan_level')" class="table-column-2 d-none d-xl-table-cell ">
                                    <div class="d-flex flex-row">
                                        Plan Level
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'plan_level' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'plan_level' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>

                                <th class="table-column-3 d-none d-xl-table-cell column-sort-disabled">
                                    <div class="d-flex flex-row">
                                        Client Users
                                    </div>
                                </th>

                                <th @click="sortByKey('last_sync_date')" class="table-column-4 d-none d-md-table-cell">
                                    <div class="d-flex flex-row w-100 justify-content-center align-items-center">
                                        Last Sync Date
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'last_sync_date' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'last_sync_date' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>

                                <th @click="sortByKey('last_gift_date')" class="table-column-4 d-none d-xl-table-cell">
                                    <div class="d-flex flex-row w-100 justify-content-center align-items-center">
                                        Last Gift Date
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'last_gift_date' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'last_gift_date' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>

                                <th @click="sortByKey('donors_value')" class="table-column-5 d-none d-sm-table-cell">
                                    <div class="d-flex flex-row w-100 justify-content-center align-items-center gap-1">
                                        Donors
                                        <img class="icon info-icon" src="/img/icons/avid-icons/help-circle.svg" data-bs-toggle="tooltip" data-placement="top" :title="timePeriodText()" :key="'donors_'+filters.time_period" alt="">
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'donors_value' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'donors_value' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>

                                <th @click="sortByKey('gifts_value')" class="table-column-5 d-none d-md-table-cell">
                                    <div class="d-flex flex-row w-100 justify-content-center align-items-center gap-1">
                                        Gifts
                                        <img class="icon info-icon" src="/img/icons/avid-icons/help-circle.svg" data-bs-toggle="tooltip" data-placement="top" :title="timePeriodText()" :key="'gifts_'+filters.time_period" alt="">
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'gifts_value' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'gifts_value' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>

                                <th @click="sortByKey('revenue_value')" class="table-column-5 d-none d-sm-table-cell" >
                                    <div class="d-flex flex-row w-100 justify-content-center align-items-center gap-1">
                                        Revenue
                                        <img class="icon info-icon" src="/img/icons/avid-icons/help-circle.svg" data-bs-toggle="tooltip" data-placement="top" :title="timePeriodText()" :key="'revenue_'+filters.time_period" alt="">
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="(sort_key === 'revenue_value' && sort_order === 'asc') ? 'sort-key-active' : ''" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="(sort_key === 'revenue_value' && sort_order === 'des') ? 'sort-key-active' : ''" alt="">
                                        </div>
                                    </div>
                                </th>

                                <th class="column-sort-disabled d-table-cell pe-3" width="1">
                                    <div class="d-flex flex-row">
                                        Actions
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(client, index) in list_shown" :key="client.id" :class="`table-row-${index + 1}`">
                                <td class="table-column-1 d-table-cell align-start">
                                    <a :href="client.home_link" class="d-flex align-items-center">
                                        <div class="d-flex align-items-center justify-content-center">
                                            <img class="avatar rounded-circle me-3 d-none d-xl-inline" :src="client.image" />
                                        </div>
                                        <div class="ms-3 flex-grow-1 text-start">
                                            {{ client.name }}
                                        </div>
                                    </a>
                                </td>

                                <td class="table-column-2 d-none d-xl-table-cell ">
                                    {{ propercase(client.plan_level) }}
                                </td>
                                <td class="table-column-3 d-none d-xl-table-cell client-users-column overlap-image-container" @mouseover="showClientUsers(index)" @mouseleave="hideClientUsers(index)">
                                    <a v-if="client.client_users" :href="'/settings/' + client.url +'/team'" class="position-relative w-100">
                                        <template v-for="(user, user_index) in client.client_users.slice(0, 4)" :key="user_index">
                                            <img :class="(client.client_users?.length > 4) ? 'overlap-fading-img-'+user_index : 'overlap-img-'+user_index"
                                                :src="user.image" class="avatar rounded-circle rounded-circle-primary-border bg-white">
                                        </template>
                                    </a>
                                    <div v-if="client.client_users && client.if_show_client_users" class="show-all-info-div px-2">
                                        <p v-for="(user, user_index) in client.client_users" :key="user_index" :class="user_index === 0 ? 'mt-2' : ''">
                                            <img :src="user.image" class="avatar rounded-circle rounded-circle-primary-border bg-white me-2">
                                            {{ user.name }}
                                        </p>
                                    </div>
                                </td>
                                <td class="table-column-4 d-none d-md-table-cell text-center">
                                    <span v-if="client.last_sync_date" :title="datetime(client.last_sync_date)" data-bs-toggle="tooltip">
                                        {{ date(client.last_sync_date) }}
                                    </span>
                                    <div v-if="ifMoreThanAWeekAgo(client.last_sync_date)">
                                        <span class="badge mx-0 bg-yellow bg-icon-warning">> 1 week ago</span>
                                    </div>
                                    <span v-if="!client.last_sync_date" class="badge mx-0 bg-red bg-icon-danger">No CRM connected</span>
                                </td>
                                <td class="table-column-4 d-none d-xl-table-cell text-center">
                                    <span v-if="client.last_gift_date" :title="datetime(client.last_gift_date)" data-bs-toggle="tooltip">
                                        {{ date(client.last_gift_date) }}
                                    </span>
                                    <span v-else-if="!client.last_sync_date">---</span>
                                    <span v-else class="badge mx-0 bg-yellow bg-icon-warning">No Data</span>
                                </td>

                                <td class="table-column-5 d-none d-sm-table-cell text-center">
                                    <span v-if="client.agency_results?.[0]?.results?.donors_value">
                                        {{ number_with_zero(client.agency_results[0].results.donors_value) }}
                                        <div>
                                            <span class="badge " :class="{ 'bg-green bg-icon-increase':( client.agency_results[0].results.donors_percentage_change > 0), 'bg-red bg-icon-decrease': (client.agency_results[0].results.donors_percentage_change < 0)}">
                                            {{ percentage_na(client.agency_results[0].results.donors_percentage_change) }}</span>
                                        </div>
                                    </span>
                                    <span v-else>---</span>
                                </td>

                                <td class="table-column-5 d-none d-md-table-cell text-center">
                                    <span v-if="client.agency_results?.[0]?.results?.gifts_value">
                                        {{ number_with_zero(client.agency_results[0].results.gifts_value) }}
                                        <div>
                                            <span class="badge " :class="{ 'bg-green bg-icon-increase':( client.agency_results[0].results.gifts_percentage_change > 0), 'bg-red bg-icon-decrease': (client.agency_results[0].results.gifts_percentage_change < 0)}">
                                            {{ percentage_na(client.agency_results[0].results.gifts_percentage_change) }}</span>
                                        </div>
                                    </span>
                                    <span v-else>---</span>
                                </td>
                                <td class="table-column-5 d-none d-sm-table-cell text-center">
                                    <span v-if="client.agency_results?.[0]?.results?.revenue_value">
                                        {{ currency_with_zero(client.agency_results[0].results.revenue_value) }}
                                        <div>
                                            <span class="badge " :class="{ 'bg-green bg-icon-increase':( client.agency_results[0].results.revenue_percentage_change > 0), 'bg-red bg-icon-decrease': (client.agency_results[0].results.revenue_percentage_change < 0)}">
                                            {{ percentage_na(client.agency_results[0].results.revenue_percentage_change) }}</span>
                                        </div>
                                    </span>
                                    <span v-else>---</span>
                                </td>

                                <td class="column-sort-disabled d-table-cell">
                                    <div class="dropdown d-flex justify-content-center">
                                        <button 
                                            class="btn btn-white btn-icon-only-md" 
                                            data-bs-toggle="dropdown" 
                                            data-bs-auto-close="true" 
                                            aria-expanded="false"
                                         aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" data-bs-toggle="tooltip" title="Actions" alt="">
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a :href="'/scorecard/' + client.url" class="dropdown-item" v-if="client.data_blends?.length > 0">
                                                <img class="icon me-2" src="/img/icons/avid-icons/note-2.svg" alt=""> View Scorecard
                                            </a>
                                            <a :href="'/benchmarks/' + client.url + '/dashboard'" class="dropdown-item">
                                                <img class="icon me-2" src="/img/icons/avid-icons/document-filter.svg" alt=""> View Benchmarks
                                            </a>
                                            <a :href="'/planning/' + client.url + '/versions'" class="dropdown-item">
                                                <img class="icon me-2" src="/img/icons/avid-icons/note-2.svg" alt=""> View Planning
                                            </a>
                                            <a v-if="client.active_plan" :href="'/planning/' + client.active_plan.url + '/assumptions'" class="dropdown-item">
                                                <img class="icon me-2" src="/img/icons/avid-icons/note-2.svg" alt=""> View Assumptions
                                            </a>
                                            <a v-if="client.active_plan" :href="'/planning/' + client.active_plan.url + '/annual'" class="dropdown-item">
                                                <img class="icon me-2" src="/img/icons/avid-icons/note-2.svg" alt=""> View Annual Plan
                                            </a>
                                            <a :href="'/settings/' + client.url +'/integrations'" class="dropdown-item">
                                                <img class="icon me-2" src="/img/icons/avid-icons/settings.svg" alt=""> View Settings
                                            </a>
                                            <a v-if="client.last_sync_date && client.data_blends?.length > 0" :href="resultsFilterUrl(client.id)" class="dropdown-item">
                                                <img class="icon me-2" src="/img/icons/avid-icons/filter-funnel-01.svg" alt=""> Edit Results Filter
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" v-model="num_per_page" @change="reloadPagination(filtered_clients)" aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ filtered_clients.length ==0 ? '0' : item_interval }} of {{ filtered_clients.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click="moveToPrevPage(filtered_clients)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click="moveToPage(page, filtered_clients)">
                                                    {{ page }}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-else>
                                                <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="page === (page_index + 1) ? 'current-page' : ''" @click="moveToPage(page, filtered_clients)">
                                                    {{ page }}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                ...
                                                </button>
                                                <button v-if="page_index >= 2 && page_index < page_index_array.length -1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{ page_index + 1 }}
                                                </button>

                                                <button v-if="page_index < page_index_array.length -2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                ...
                                                </button>
                                                <button :class="page_index === (page_index_array.length -1) ? 'current-page' : ''" class="btn btn-none btn-icon-only-md" @click="moveToPage(page_index_array.length, filtered_clients)" :key="page_index_array.length">
                                                    {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click="moveToNextPage(filtered_clients)" :disabled="page_index === page_count -1" data-bs-toggle="tooltip" title="Next page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>

                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import vSelect from "vue3-select";
import tablePaginationMixin from '../../mixins/table_pagination';
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        Swal, vSelect, Multiselect
    },
    props: ['clients', 'user', 'customization'],
    mixins: [tablePaginationMixin],
    data() {
        return {
            local_customization: null,
            filtered_clients: [],
            clients_summary:{
                donors_current_period: 0,
                donors_prior_period: 0,
                donors_percentage_change: 0,
                gifts_current_period: 0,
                gifts_prior_period: 0,
                gifts_percentage_change: 0,
                revenue_current_period: 0,
                revenue_prior_period: 0,
                revenue_percentage_change: 0,
            },
            filters:{
                agency_user: {
                    category:"",
                    text: "All Agency Users",
                    value: -1
                },
                time_period: 'current_month'
            },
            all_agency_users: [],
            filtered_agency_users: [],
            list_shown: [],
            search_key: '',
            sort_key: 'name',
            sort_order: 'asc',
        };
    },
    beforeMount() {
        if(this.customization && this.customization != 'null')
            this.local_customization = this.customization;

        this.filtered_clients = [...this.clients];
        this.loadTableData();
        this.loadFilterOptions();
        this.handleFilterSelection();
    },
    mounted() {
        this.reloadPagination(this.filtered_clients);
    },
    updated() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

        for (var i = 0; i < tooltipTriggerList.length; i++) {
            (function(index) {
            tooltipTriggerList[index].addEventListener('click', function() {
                // Hide the tooltip using the index passed to the closure
                tooltipList[index].hide();
            });
            tooltipTriggerList[index].addEventListener('mouseleave', function() {
                // Hide the tooltip using the index passed to the closure
                tooltipList[index].hide();
            });
            })(i);
        }
    },
    methods: {
        timePeriodText(){
            if(this.filters.time_period == 'current_month')
                return 'Current Month (' + new Date().toLocaleString('default', { month: 'short' }) + ')';
            else if(this.filters.time_period == 'last_month')
                // Set it to last month, not htis month
                return 'Last Month (' + new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toLocaleString('default', { month: 'short' }) + ')';
            else if(this.filters.time_period == 'fytd')
                return 'Fiscal Year to Date';
        },
        loadTableData() {
            this.clients_summary = {
                donors_current_period: 0,
                donors_prior_period: 0,
                donors_percentage_change: 0,
                gifts_current_period: 0,
                gifts_prior_period: 0,
                gifts_percentage_change: 0,
                revenue_current_period: 0,
                revenue_prior_period: 0,
                revenue_percentage_change: 0,
            },
            this.filtered_clients.forEach((client, client_index) => {
                client.if_show_client_users = false;
                client.if_show_agency_users = false;
                if(client.agency_results && client.agency_results[0] && client.agency_results[0].results){
                    if (typeof client.agency_results[0].results == 'string'){
                       client.agency_results[0].results = JSON.parse(client.agency_results[0].results);
                    }
                    this.loadTableDataForEachRow(client_index);
                }
            });

            if (this.clients_summary.donors_prior_period > 0) {
                this.clients_summary.donors_percentage_change = ((this.clients_summary.donors_current_period - this.clients_summary.donors_prior_period) / this.clients_summary.donors_prior_period);
            } else {
                this.clients_summary.donors_percentage_change = 0;
            }

            if (this.clients_summary.gifts_prior_period > 0) {
                this.clients_summary.gifts_percentage_change = ((this.clients_summary.gifts_current_period - this.clients_summary.gifts_prior_period) / this.clients_summary.gifts_prior_period) ;
            } else {
                this.clients_summary.gifts_percentage_change = 0;
            }

            if (this.clients_summary.revenue_prior_period > 0) {
                this.clients_summary.revenue_percentage_change = ((this.clients_summary.revenue_current_period - this.clients_summary.revenue_prior_period) / this.clients_summary.revenue_prior_period) ;
            } else {
                this.clients_summary.revenue_percentage_change = 0;
            }
            this.reloadPagination(this.filtered_clients);
        },
        showClientUsers(index){
            this.filtered_clients[index].if_show_client_users = true;
            this.filtered_clients[index].if_show_agency_users = false;
            this.$forceUpdate();
        },
        hideClientUsers(index){
            this.filtered_clients[index].if_show_client_users = false;
            this.$forceUpdate();
        },
        showAgencyUsers(index){
            this.filtered_clients[index].if_show_agency_users = true;
            this.filtered_clients[index].if_show_client_users = false;
            this.$forceUpdate();
        },
        hideAgencyUsers(index){
            this.filtered_clients[index].if_show_agency_users = false;
            this.$forceUpdate();
        },
        loadFilterOptions(){
            this.all_agency_users = this.all_agency_users.sort((a, b) => {
                const aFullName = `${a.first_name || ''} ${a.last_name || ''}`.trim();
                const bFullName = `${b.first_name || ''} ${b.last_name || ''}`.trim();
                return aFullName.localeCompare(bFullName);
            });
            var all_users_option = {
                category:"",
                text: "All Agency Users",
                value: -1
            };
            this.all_agency_users.splice(0, 0, all_users_option);
            this.filtered_agency_users = [...this.all_agency_users];

            if(this.local_customization)
                this.filters.time_period = this.local_customization.filter.time_period;
        },
        loadTableDataForEachRow(client_index){
            var self = this;
            // load users and sort by last name
            this.filtered_clients[client_index].client_users = this.filtered_clients[client_index].users.filter(user => !user.agency_id).sort((a, b) => a.image.localeCompare(b.image));
            this.filtered_clients[client_index].agency_users = this.filtered_clients[client_index].users.filter(user => user.agency_id).sort((a, b) => a.image.localeCompare(b.image));//&& user.id == this.user.id

            this.filtered_clients[client_index].agency_users.forEach((agency_user) =>{
                var index = self.all_agency_users.findIndex(user => user.id == agency_user.id);
                if (index == -1 && agency_user.agency_id == this.user.agency_id){
                    agency_user.category = "";
                    agency_user.text = agency_user.name;
                    agency_user.value = agency_user.id;
                    self.all_agency_users.push(agency_user);
                }
            })

            //load recent results
            if (!this.filtered_clients[client_index].agency_results || !this.filtered_clients[client_index].agency_results[0]) {
                return;
            }

            var temp = this.filtered_clients[client_index].agency_results[0].results;
            if(this.filters.time_period == 'fytd'){
                temp.donors_value = temp['donors_fytd_current'];
                temp.donors_prior_value = temp['donors_fytd_prior'];
                temp.gifts_value = temp['gifts_fytd_current'];
                temp.gifts_prior_value = temp['gifts_fytd_prior'];
                temp.revenue_value = parseFloat(temp['revenue_fytd_current']);
                temp.revenue_prior_value = parseFloat(temp['revenue_fytd_prior']);
            }
            else{
                temp.donors_value = temp['donors_' + this.filters.time_period];
                temp.donors_prior_value = temp['donors_prior_' + this.filters.time_period];
                temp.gifts_value = temp['gifts_' + this.filters.time_period];
                temp.gifts_prior_value = temp['gifts_prior_' + this.filters.time_period];
                temp.revenue_value = parseFloat(temp['revenue_' + this.filters.time_period]);
                temp.revenue_prior_value = parseFloat(temp['revenue_prior_' + this.filters.time_period]);
            }

            temp.donors_percentage_change = (temp.donors_value - temp.donors_prior_value)/ temp.donors_prior_value;
            temp.gifts_percentage_change = (temp.gifts_value - temp.gifts_prior_value)/ temp.gifts_prior_value;
            temp.revenue_percentage_change = (temp.revenue_value - temp.revenue_prior_value)/temp.revenue_prior_value;

            this.filtered_clients[client_index].agency_results[0].results = temp;
            this.clients_summary.donors_current_period += temp.donors_value;
            this.clients_summary.gifts_current_period += temp.gifts_value;
            this.clients_summary.revenue_current_period += temp.revenue_value;
            this.clients_summary.donors_prior_period += temp.donors_prior_value;
            this.clients_summary.gifts_prior_period += temp.gifts_prior_value;
            this.clients_summary.revenue_prior_period += temp.revenue_prior_value;
        },
        fetchClientOptions(search_key){
            if(search_key == "")
                this.filtered_agency_users = [...this.all_agency_users];
            else
                this.filtered_agency_users = [...this.all_agency_users.filter(user => user.name && user.name.toLowerCase().includes(search_key.toLowerCase()))];
        },
        ifMoreThanAWeekAgo(date) {
            if (date){
                const date_to_check = new Date(date);
                const today = new Date();
                const one_week_ago = new Date();
                one_week_ago.setDate(today.getDate() - 7);

                return date_to_check < one_week_ago;
            } else {
                return false;
            }

        },
        handleFilterSelection(){
            var filtered_list = [];
            var self = this;

            this.clients.forEach(client => {
                let in_search = this.search_key == '' || client.name.toLowerCase().includes(this.search_key.toLowerCase());

                if (in_search){
                    if(self.filters.agency_user && self.filters.agency_user.value != -1){
                        if (client.agency_users && client.agency_users.find(user => user.id == self.filters.agency_user.id)){
                            filtered_list.push(client);
                        }
                    } else {
                        filtered_list.push(client);
                    }
                }
            });

            this.filtered_clients = filtered_list;
            this.loadTableData();
            this.sortData();
            this.reloadPagination(this.filtered_clients);
            var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))
            var dropdownList = dropdownElementList.map(function (dropdownToggleEl) {
                return new bootstrap.Dropdown(dropdownToggleEl)
            })
            dropdownList.forEach(dropdown => {
                dropdown.hide();
            });
            this.$forceUpdate();
        },
        sortByKey(key) {
            if (this.sort_key === key) {
                this.sort_order = (this.sort_order === 'asc') ? 'des' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_order = 'asc';
            }
            this.sortData();
        },
        sortData() {
            if(this.sort_key == 'name' || this.sort_key == 'plan_level'){
                if (this.sort_order === 'asc') {
                    this.filtered_clients.sort((a, b) => a[this.sort_key].localeCompare(b[this.sort_key]));
                } else {
                    this.filtered_clients.sort((a, b) => b[this.sort_key].localeCompare(a[this.sort_key]));
                }
            } else {
                var self = this;
                if (this.sort_order === 'asc') {
                    this.filtered_clients.sort((a, b) =>{
                        if (a.agency_results?.[0]?.results && b.agency_results?.[0]?.results){
                            if (a.agency_results[0].results[self.sort_key] && b.agency_results[0].results[self.sort_key]){
                                return a.agency_results[0].results[self.sort_key] - b.agency_results[0].results[self.sort_key]
                            } else{
                                if (!a.agency_results[0].results[self.sort_key]) return -1;
                                if (!b.agency_results[0].results[self.sort_key]) return 1;
                            }
                        }else {
                            if (!a.agency_results || !a.agency_results[0] || !a.agency_results[0].results ) return -1;
                            if (!b.agency_results || !b.agency_results[0] || !b.agency_results[0].results) return 1;
                        }
                    });
                } else {
                    this.filtered_clients.sort((a, b) =>{
                        if (a.agency_results?.[0]?.results && b.agency_results?.[0]?.results){
                            if (a.agency_results[0].results[self.sort_key] && b.agency_results[0].results[self.sort_key]){
                                return b.agency_results[0].results[self.sort_key] - a.agency_results[0].results[self.sort_key]
                            } else{
                                if (!a.agency_results[0].results[self.sort_key]) return 1;
                                if (!b.agency_results[0].results[self.sort_key]) return -1;
                            }
                        }else {
                            if (!a.agency_results || !a.agency_results[0] || !a.agency_results[0].results ) return 1;
                            if (!b.agency_results || !b.agency_results[0] || !b.agency_results[0].results) return -1;
                        }
                    });
                }
            }
            this.reloadPagination(this.filtered_clients);
        },
        addClientUrl() {
            // Placeholder URL for adding a new client
            return `/admin/agency/${this.user.agency_id}/client/add`;
        },
        resultsFilterUrl(clientId) {
            return `/admin/agency/${this.user.agency_id}/client/${clientId}/results`;
        },
        saveTimePeriod(){
            this.handleFilterSelection();

            if(this.local_customization == null) {
                this.local_customization = {
                    id: null,
                    action: 'sort',
                    user_id: this.user.id,
                    filter: {
                        time_period: this.filters.time_period
                    }
                };
            }
            else
                this.local_customization.filter.time_period = this.filters.time_period;

            if(this.local_customization.id == null) {
                var self = this;
                window.axios.post('/api/customization', this.local_customization)
                    .then(response => {
                        //update the customization object
                        this.local_customization = response.data.data;
                    });
            }
            else {
                window.axios.put('/api/customization/' + this.local_customization.id,  this.local_customization);
            }
        }
    }
}
</script>